import { Component, inject } from '@angular/core';
import { DeviceTableComponent as EpDeviceTableComponent, DeviceTableRow } from '@ep/shared';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { Device } from '@shared/models';
import { DevicesApiService } from '@app/areas/merchants/services/devices.api.service';
import { deviceConnectionStatusSeverity } from '@app/areas/merchants/utils/device-status';

@Component({
  selector: 'app-device-table',
  templateUrl: './device-table.component.html',
  styleUrls: ['./device-table.component.scss'],
  standalone: true,
  imports: [EpDeviceTableComponent, AsyncPipe],
})
export class DeviceTableComponent {
  private readonly devicesApiService = inject(DevicesApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  // Coalition renders every status tag in the same color; see deviceConnectionStatusSeverity.
  protected readonly statusSeverity = deviceConnectionStatusSeverity;

  protected devices$: Observable<Device[]> = this.route.parent!.parent!.paramMap.pipe(
    map((params) => Number(params.get('merchantId'))),
    switchMap((merchantId) => this.devicesApiService.getByMerchantId(merchantId))
  );

  protected addNew(): void {
    this.router.navigate(['new'], { relativeTo: this.route });
  }

  protected rowClick(device: DeviceTableRow): void {
    this.router.navigate([device.DeviceId], { relativeTo: this.route });
  }
}
